import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

type Props = {
  onClose: () => void;
};

const Error = ({ onClose }: Props) => {
  return (
    <Box sx={{ p: 3, pt: 4, textAlign: "center" }}>
      <CancelIcon color="error" sx={{ fontSize: "6rem" }} />
      <Typography align="center" gutterBottom variant="body1">
      Oops! We encountered an issue while creating your brief. Please try again.
      If the problem persists, feel free to contact our support team for assistance.
      </Typography>
      <Box sx={{ pt: 3, textAlign: "center" }}>
        <Button
          variant="outlined"
          color="primary"
          type="button"
          onClick={onClose}
          sx={{ mr: 3 }}
        >
          Return to dashboard
        </Button>
        <a
          href="https://calendly.com/tomwinter/virtual-coffee"
          target="_blank"
          rel="noreferrer"
        >
          <Button variant="contained" color="primary" type="button">
            Let’s meet
          </Button>
        </a>
      </Box>
    </Box>
  );
};

export default Error;
